<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>گفتگوی جدید</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="150">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
                <div class="card-bg bg-20"></div>
            </div>

            <div class="card card-style text-center mb-3">
                <div class="content pb-2">
                    <div>
                        <i class="fa fa-info-circle  color-green1-dark fa-3x pt-3 icon-size"></i>
                    </div>
                    <h4 class="font-700 mt-4 line-height-xl">جهت مشاهده ی جزییات گفتگو به CRM تحت وب مراجعه کنید.</h4>
                   
                </div>
            </div>

           
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                info: null
            }
        },
        methods: {
            GetCompanyItem() {
                this.$http.get("Person/GetLocalCompany")
                   .then(data => {
                        this.info = data.data;
                    });
            },
        },
        
    }
</script>